/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    amount: "0",
    index: "1",
    spendId: "10",
    title: "Tổng số thuế TNDN phải nộp",
  },
  {
    id: uuidV4(),
    index: "",
    spendId: "",
    title: "Trong đó",
  },
  {
    id: uuidV4(),
    amount: "",
    index: "1.1",
    spendId: "11",
    title: "Thuế TNDN phải nộp của hoạt động sản xuất kinh doanh",
  },
  {
    id: uuidV4(),
    amount: "",
    index: "1.2",
    spendId: "12",
    title: "Thuế TNDN phải nộp của hoạt động chuyển nhượng bất động sản",
  },
  {
    id: uuidV4(),
    amount: "",
    index: "1.3",
    spendId: "13",
    title: "Thuế TNDN phải nộp khác",
  },
  {
    id: uuidV4(),
    amount: "",
    index: "2",
    spendId: "14",
    title: "Số thuế TNDN được giảm",
  },
  {
    id: uuidV4(),
    index: "",
    spendId: "",
    title: "Trong đó",
  },
  {
    id: uuidV4(),
    amount: "0",
    index: "2.1",
    spendId: "15",
    title: "Thuế TNDN được giảm của hoạt động sản xuất kinh doanh",
  },
  {
    id: uuidV4(),
    amount: "0",
    index: "2.2",
    spendId: "16",
    title: "Thuế TNDN được giảm của hoạt động chuyển nhượng bất động sản",
  },
  {
    id: uuidV4(),
    amount: "0",
    index: "2.3",
    spendId: "17",
    title: "Thuế TNDN được giảm khác",
  },
];

export default function CorporateIncomeTaxTable21({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (spendId) => ["10", "14", "15", "16", "17"].includes(spendId);
  const isBold = (spendId) => ["10", "14"].includes(spendId);

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Số tiền
              </Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.spendId) ? 900 : 400,
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.spendId) ? 900 : 400,
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.spendId) ? 900 : 400,
                  }}
                >
                  {item.spendId ? `[${item.spendId}]` : ""}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.spendId) ? "#ddeff3" : "transparent",
                    fontWeight: isBold(item.spendId) ? 900 : 400,
                  }}
                >
                  {isDisabled(item.spendId) || !item.index ? (
                    item.amount
                  ) : (
                    <InputTable
                      id={item.id}
                      value={item.amount}
                      name="amount"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, id });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
